import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PhoneCall, ArrowRight } from "lucide-react";
import { ActivityRow } from "./ActivityRow";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ApiActivityCard = () => {
  const [items, setItems] = useState(null);
  useEffect(() => { axios.get(`${API}/activity?limit=10`).then((r) => setItems(r.data.items)).catch(() => setItems([])); }, []);
  return (
    <Card className="bg-white border-0 shadow-lg" data-testid="api-activity-card">
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-xl flex items-center gap-2"><PhoneCall className="w-5 h-5 text-indigo-600" /> Phone agent &amp; API activity</CardTitle>
          <Link to="/activity" className="text-sm text-blue-600 hover:underline inline-flex items-center gap-1" data-testid="api-activity-view-all">View all <ArrowRight className="w-3 h-3" /></Link>
        </div>
      </CardHeader>
      <CardContent>
        {items === null ? <p className="text-sm text-slate-400">Loading…</p> : items.length === 0 ? (
          <p className="text-sm text-slate-400" data-testid="api-activity-empty">No API or phone-agent activity yet. Actions taken with an API key (bookings, cancellations, statements sent…) will show up here.</p>
        ) : <div className="divide-y" data-testid="api-activity-list">{items.map((i) => <ActivityRow key={i.id} item={i} compact />)}</div>}
      </CardContent>
    </Card>
  );
};
